/* The Money Duck — interactive bits (no framework) */

(function () {
  'use strict';

  /* ---------- FAQ accordion ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.faq-q');
    if (!btn) return;
    var item = btn.closest('.faq-item');
    if (!item) return;
    var wasOpen = item.classList.contains('open');
    // Close siblings within the same list.
    var list = item.parentElement;
    if (list) {
      list.querySelectorAll('.faq-item.open').forEach(function (el) { el.classList.remove('open'); });
    }
    if (!wasOpen) item.classList.add('open');
  });

  /* ---------- Method jars: active state ---------- */
  document.addEventListener('click', function (e) {
    var jar = e.target.closest('.jar');
    if (!jar) return;
    var group = jar.parentElement;
    if (!group) return;
    group.querySelectorAll('.jar.active').forEach(function (el) { el.classList.remove('active'); });
    jar.classList.add('active');
  });

  /* ---------- Tips grid: category filter chips ---------- */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('.tips-chip');
    if (!chip) return;
    var section = chip.closest('[data-tips]');
    if (!section) return;
    var filter = chip.getAttribute('data-tips-filter');

    section.querySelectorAll('.tips-chip').forEach(function (c) {
      var active = c === chip;
      c.classList.toggle('is-active', active);
      c.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    section.querySelectorAll('.tips-card').forEach(function (card) {
      var match = filter === 'all' || card.getAttribute('data-tips-category') === filter;
      card.hidden = !match;
    });
  });

  /* ---------- Mobile drawer ---------- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-drawer-open]');
    var close = e.target.closest('[data-drawer-close]');
    var drawer = document.querySelector('.mobile-drawer');
    if (!drawer) return;
    if (open) { drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); }
    if (close) { drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); }
    // Close drawer on link tap.
    if (e.target.closest('.mobile-links a')) {
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
    }
  });

  /* ---------- Conversation cards deck ---------- */
  function layoutDeck(stage) {
    var cards = stage.querySelectorAll('.conv-card');
    var total = cards.length;
    var idx = parseInt(stage.dataset.idx || '0', 10);
    cards.forEach(function (card, i) {
      var offset = ((i - idx) + total) % total;
      var transform = 'translate(-50%,-50%)';
      var opacity = 1;
      var z = 10;
      if (offset === 0) {
        transform = 'translate(-50%, -50%) rotate(-3deg)';
        z = 30;
      } else if (offset === 1) {
        var tx = window.innerWidth <= 720 ? -47 : -42;
        var rot = window.innerWidth <= 720 ? 3 : 4;
        transform = 'translate(' + tx + '%, -52%) rotate(' + rot + 'deg)';
        z = 20;
        opacity = 0.85;
      } else if (offset === 2) {
        var rot2 = window.innerWidth <= 720 ? -5 : -7;
        transform = 'translate(-50%, -54%) rotate(' + rot2 + 'deg)';
        z = 10;
        opacity = 0.65;
      } else {
        opacity = 0;
        z = 0;
        transform = 'translate(-50%, -50%) scale(0.9)';
      }
      card.style.transform = transform;
      card.style.zIndex = z;
      card.style.opacity = opacity;
      card.style.pointerEvents = offset === 0 ? 'auto' : 'none';
    });
    var counter = stage.parentElement.querySelector('[data-deck-counter]');
    if (counter) {
      counter.textContent = (idx + 1) + ' / ' + total;
    }
  }

  function initDecks() {
    document.querySelectorAll('.cards-stage').forEach(function (stage) {
      stage.dataset.idx = '0';
      layoutDeck(stage);
      var wrap = stage.closest('[data-deck]');
      if (!wrap) return;
      var next = wrap.querySelector('[data-deck-next]');
      var prev = wrap.querySelector('[data-deck-prev]');
      var total = stage.querySelectorAll('.conv-card').length;
      function go(delta) {
        var i = parseInt(stage.dataset.idx, 10);
        stage.dataset.idx = String(((i + delta) % total + total) % total);
        layoutDeck(stage);
      }
      if (next) next.addEventListener('click', function () { go(1); });
      if (prev) prev.addEventListener('click', function () { go(-1); });
      stage.addEventListener('click', function (e) {
        var card = e.target.closest('.conv-card');
        if (!card) return;
        // Only the top card is interactive.
        if (card.style.pointerEvents !== 'auto') return;
        go(1);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDecks);
  } else {
    initDecks();
  }
})();

/* ---------- Side cart drawer ---------- */
(function () {
  'use strict';

  var SECTION = 'cart-drawer';
  // Native fetch captured before we wrap window.fetch, so our own internal
  // requests don't re-trigger the global sync below.
  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  var lastFocus = null;

  function drawer() { return document.querySelector('[data-cart-drawer]'); }

  function openDrawer() {
    var d = drawer();
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cart-drawer-open');
    syncNow(); // make sure contents reflect the latest cart
    var x = d.querySelector('[data-cart-close]');
    if (x && x.focus) setTimeout(function () { x.focus(); }, 60);
  }

  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cart-drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ----- Header badge ----- */
  function setBadge(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (b) {
      var prev = parseInt(b.textContent, 10) || 0;
      b.textContent = count;
      if (count > 0) { b.hidden = false; b.removeAttribute('hidden'); }
      else { b.hidden = true; b.setAttribute('hidden', ''); }
      if (count > prev) {
        b.classList.remove('bump');
        void b.offsetWidth; // restart the animation
        b.classList.add('bump');
      }
    });
  }

  /* ----- Toast ----- */
  function showToast(msg) {
    var t = document.querySelector('[data-cart-toast]');
    if (!t) {
      t = document.createElement('div');
      t.className = 'cart-toast';
      t.setAttribute('data-cart-toast', '');
      t.setAttribute('role', 'status');
      t.innerHTML = '<span class="cart-toast__dot"></span><span data-cart-toast-msg></span>';
      document.body.appendChild(t);
    }
    t.querySelector('[data-cart-toast-msg]').textContent = msg;
    // Force reflow so re-triggering restarts the transition.
    void t.offsetWidth;
    t.classList.add('is-show');
    clearTimeout(t.__timer);
    t.__timer = setTimeout(function () { t.classList.remove('is-show'); }, 2600);
  }

  /* ----- Pull fresh drawer HTML + count via Section Rendering API ----- */
  var syncing = false, syncAgain = false;
  function syncNow() {
    if (!nativeFetch) return;
    if (syncing) { syncAgain = true; return; }
    syncing = true;
    nativeFetch(window.location.pathname + '?sections=' + SECTION, {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data[SECTION];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-contents]');
        var live = document.querySelector('[data-cart-contents]');
        if (fresh && live) {
          // Remember the shipping bar's width so it can animate to the new one
          // (a plain innerHTML swap would jump straight to the final width).
          var oldFill = live.querySelector('[data-shipbar-fill]');
          var prevWidth = oldFill ? oldFill.style.width : null;
          live.innerHTML = fresh.innerHTML;
          var newFill = live.querySelector('[data-shipbar-fill]');
          if (newFill && prevWidth && prevWidth !== newFill.style.width) {
            var targetWidth = newFill.style.width;
            newFill.style.width = prevWidth;
            void newFill.offsetWidth;
            newFill.style.width = targetWidth;
          }
        }
        var root = doc.querySelector('[data-cart-drawer]');
        if (root) {
          var c = parseInt(root.getAttribute('data-cart-total'), 10) || 0;
          setBadge(c);
          var d = drawer();
          if (d) d.setAttribute('data-cart-total', c);
        }
      })
      .catch(function () {})
      .then(function () {
        syncing = false;
        if (syncAgain) { syncAgain = false; syncNow(); }
      });
  }

  var syncTimer;
  function syncSoon() {
    clearTimeout(syncTimer);
    // Debounced + slightly delayed so it settles after any optimistic UI
    // (e.g. binder.liquid's own badge bump) and coalesces rapid clicks.
    syncTimer = setTimeout(syncNow, 450);
  }

  /* ----- Catch every cart mutation, whoever made it ----- */
  if (nativeFetch) {
    window.fetch = function () {
      var url = arguments[0];
      var path = (typeof url === 'string') ? url : (url && url.url) || '';
      var p = nativeFetch.apply(window, arguments);
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(path)) {
        p.then(function (res) { if (res && res.ok) syncSoon(); }).catch(function () {});
      }
      return p;
    };
  }

  /* ----- In-drawer quantity + remove ----- */
  function changeLine(line, quantity) {
    if (!nativeFetch) return;
    nativeFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function () { syncNow(); })
      .catch(function () { syncNow(); });
  }

  /* ----- AJAX add-to-cart for standard product forms ----- */
  function isAddForm(form) {
    var action = form.getAttribute('action') || '';
    if (/\/cart\/add/.test(action)) return true;
    var ft = form.querySelector('input[name="form_type"]');
    return ft && ft.value === 'product';
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form');
    if (!form || !isAddForm(form) || !nativeFetch) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    nativeFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, data: d }; });
      })
      .then(function (res) {
        if (!res.ok) {
          showToast((res.data && res.data.description) || 'Could not add to cart');
          return;
        }
        var item = (res.data && res.data.items) ? res.data.items[0] : res.data;
        var title = (item && (item.product_title || item.title)) || 'Item';
        showToast('Added to cart — ' + title);
        syncNow();
      })
      .catch(function () { showToast('Could not add to cart'); })
      .then(function () { if (btn) btn.disabled = false; });
  });

  /* ----- Delegated clicks: open / close / qty / remove ----- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); return; }

    var line = e.target.closest('[data-cart-line]');
    if (!line) return;
    var inc = e.target.closest('[data-cart-qty-inc]');
    var dec = e.target.closest('[data-cart-qty-dec]');
    var rem = e.target.closest('[data-cart-remove]');
    if (!inc && !dec && !rem) return;
    e.preventDefault();

    var ln = parseInt(line.getAttribute('data-cart-line'), 10);
    var valEl = line.querySelector('[data-cart-qty-val]');
    var cur = parseInt(valEl ? valEl.textContent : '1', 10) || 1;
    var next = rem ? 0 : (inc ? cur + 1 : cur - 1);
    if (valEl && next > 0) valEl.textContent = next; // optimistic
    line.classList.add('is-busy');
    changeLine(ln, next);
  });

  /* ----- Escape to close ----- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = drawer();
    if (d && d.classList.contains('is-open')) closeDrawer();
  });
})();

/* ---------- Scroll reveal + nav scroll state ---------- */
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // The CSS only hides [data-reveal] under html.js-reveal, so content stays
  // visible if this script never runs.
  document.documentElement.classList.add('js-reveal');

  var observer = null;
  if ('IntersectionObserver' in window && !reduced) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  }

  function watch(root) {
    var els = (root || document).querySelectorAll('[data-reveal]:not(.revealed)');
    Array.prototype.forEach.call(els, function (el) {
      if (observer) observer.observe(el);
      else el.classList.add('revealed');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { watch(document); });
  } else {
    watch(document);
  }

  // Theme editor: re-rendered sections should never sit invisible.
  document.addEventListener('shopify:section:load', function (e) {
    var els = e.target.querySelectorAll('[data-reveal]');
    Array.prototype.forEach.call(els, function (el) { el.classList.add('revealed'); });
  });

  /* ----- Nav shadow once the page scrolls ----- */
  var nav = document.querySelector('.nav');
  if (nav) {
    var onScroll = function () {
      nav.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();
